import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { ref } from 'vue';

// Components
import DialogConsole from '@components/dialog/DialogConsole.vue';
import QBtnValid from '@components/form/QBtnValid.vue';

// Personal libs
import { SkipLinkEnum } from 'src/shared/enum/skip-link.enum';

/**
 * Reactive datas
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutFooterConsole',
  setup(__props) {

// Vendor
const showConsole = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    id: _unref(SkipLinkEnum).NAVIGATION_FOOTER,
    elevated: !_ctx.$q.dark.isActive,
    class: "bg-primary text-white q-pa-xs scroll",
    role: "contentinfo",
    tabindex: "-1"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(QBtnValid, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showConsole.value = true)),
          "icon-left": 'analytics',
          label: 'Afficher la console'
        })
      ]),
      _createVNode(DialogConsole, {
        show: showConsole.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showConsole.value = false))
      }, null, 8 /* PROPS */, ["show"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "elevated"]))
}
}

})